import { jsx as _jsx } from "react/jsx-runtime";
import createSvgIcon from "./utils/createSvgIcon";
export default createSvgIcon([
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3.7322 8.7322A2.5 2.5 0 0 1 5.5 8H7c.5523 0 1 .4477 1 1s-.4477 1-1 1H5.5a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5H13a.5.5 0 0 0 .3536-.1464A.5.5 0 0 0 13.5 19.5v-9a.5.5 0 0 0-.1464-.3536A.5.5 0 0 0 13 10h-1.5c-.5523 0-1-.4477-1-1s.4477-1 1-1H13a2.5003 2.5003 0 0 1 2.5 2.5v9c0 .663-.2634 1.2989-.7322 1.7678A2.5 2.5 0 0 1 13 22H5.5A2.5 2.5 0 0 1 3 19.5v-9a2.5 2.5 0 0 1 .7322-1.7678",
        clipRule: "evenodd"
    }, "0"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.75 15c0 .5523-.4477 1-1 1h-3c-.5523 0-1-.4477-1-1s.4477-1 1-1h3c.5523 0 1 .4477 1 1m2-13c-.5523 0-1 .4477-1 1v2.25c0 .5523.4477 1 1 1s1-.4477 1-1V3c0-.5523-.4477-1-1-1m7.75 7.75c0-.5523-.4477-1-1-1h-2.25c-.5523 0-1 .4477-1 1s.4477 1 1 1h2.25c.5523 0 1-.4477 1-1m-2.2431-5.507c-.3905-.3904-1.0237-.3904-1.4142 0l-1.6125 1.6126c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0l1.6125-1.6125c.3905-.3905.3905-1.0237 0-1.4142M8.5 8.5a.5.5 0 0 0 0 1H10a.5.5 0 0 0 0-1zM6 9c0-1.3807 1.1193-2.5 2.5-2.5H10c1.3807 0 2.5 1.1193 2.5 2.5s-1.1193 2.5-2.5 2.5H8.5C7.1193 11.5 6 10.3807 6 9",
        clipRule: "evenodd"
    }, "1")
], "ClipboardRemove", {
    "style": {
        "fill": "none"
    },
    "viewBox": "0 0 24 24"
});
